
import * as React from 'react';
import { ListViewModelImpl } from '../../../toolkit/horizontallist/listviewmodel';
import '../../../toolkit/carousel/carousel.css';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { BannerCardComponent } from './bannercard/bannercardcomponent';
import { BannerDto } from 'src/com/sixdee/crbtportal/core/dto/banner/bannerdto';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../toolkit/player/playerwithprogress/playerwithprogressimpl';


export class BannerViewModelImpl extends ListViewModelImpl<BannerDto>
{


    
    private audioPlayerWithProgress :AudioPlayerWithProgress;
    constructor(context: BaseContext, private onBannerClick: any, private stopAutoPlay: any,
        private startAutoPlay: any)
    {
        super(context);
        this.onToneSelected = this.onToneSelected.bind(this);
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());

    }

    getOffset(): number
    {
        return 5;
    }

    getView(t: BannerDto, position: number): boolean | JSX.Element 
    {
        return (
        <>
         {/* <div className="swiper-slide">
                            <div className="card">
                                <div className="sliderText">
                                    <h3>{t.getToneName()}</h3>
                                </div>
                                <div className="content">
                                    <p>{t.getArtistName()}</p>
                                    <a href="#">{"Read More"}</a>
                                </div>
                            </div>
                         </div> */}
                         <BannerCardComponent stopAutoPlay={this.stopAutoPlay} startAutoPlay={this.startAutoPlay} audioPlayerWithProgress={this.audioPlayerWithProgress} key={position} bannerDto={t}  position={position} onBannerClick={this.onBannerClick} context={this.getContext()}/>
        </>
        );
    }

    private onToneSelected(): void
    {
       
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerviewmodel.tsx